"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _TradeAllyPageTitle = _interopRequireDefault(require("../components/PageTitle/TradeAllyPageTitle"));

var _CardList = _interopRequireDefault(require("../components/CardList/CardList"));

var _SectionList = _interopRequireDefault(require("../components/SectionList/SectionList"));

var _TradeAllySectionTitle = _interopRequireDefault(require("../components/SectionTitle/TradeAllySectionTitle"));

var _SectionBody = _interopRequireDefault(require("../components/SectionBody/SectionBody"));

var _SectionImages = _interopRequireDefault(require("../components/SectionImages/SectionImages"));

var _HeroCard = _interopRequireDefault(require("../components/HeroCard/HeroCard"));

var _SectionTable = _interopRequireDefault(require("../components/SectionTable/SectionTable"));

var _SectionCTALink = _interopRequireDefault(require("../components/SectionCTALink/SectionCTALink"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* eslint-disable camelcase */
var CenhubTradeAllyTemplate = function CenhubTradeAllyTemplateComponent(_ref) {
  var dataClient = _ref.dataClient,
      pageData = _ref.pageData;
  var sections = pageData.sections,
      linkedContent = pageData.linkedContent;
  var componentMap = {
    section_page_title: _TradeAllyPageTitle["default"],
    section_title: _TradeAllySectionTitle["default"],
    section_body: _SectionBody["default"],
    section_card_list: _CardList["default"],
    section_list: _SectionList["default"],
    section_images: _SectionImages["default"],
    section_hero_card: _HeroCard["default"],
    section_table: _SectionTable["default"],
    section_cta_link: _SectionCTALink["default"]
  };
  return sections.map(function (sliceData, idx) {
    var Component = componentMap[sliceData.slice_type];
    var key = "".concat(sliceData.slice_type, "-").concat(idx);
    return /*#__PURE__*/_react["default"].createElement(Component, {
      sliceData: sliceData,
      dataClient: dataClient,
      linkedContent: linkedContent,
      key: key
    });
  });
};

CenhubTradeAllyTemplate.propTypes = {
  dataClient: _propTypes["default"].shape({}).isRequired,
  pageData: _propTypes["default"].shape({}).isRequired
};
var _default = CenhubTradeAllyTemplate;
exports["default"] = _default;